import React from 'react';
import './Header.css';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-brand">
          <img src="/logo.png" alt="OSGENIUS Logo" className="header-logo" />
          <h1 className="header-title">OSGENIUS - FERRAMENTAS 3D</h1>
        </div>
        <div className="header-user">
          <div className="user-info">
            <span className="user-greeting">Olá,</span>
            <span className="user-name">{user?.nome || 'Usuário'}</span>
          </div>
          <button onClick={logout} className="logout-button">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            Sair
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
